import React, { useState } from 'react';
import config from '../config/environment';

const CreateRoom = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    roomId: '',
    playerName: '',
    maxPlayers: 4,
    isPrivate: false,
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const generateRoomId = () => {
    const roomId = Math.random().toString(36).substring(2, 8).toUpperCase();
    setFormData(prevData => ({ ...prevData, roomId }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.roomId || !formData.playerName) {
      setError('Room ID and player name are required');
      return;
    }

    if (formData.isPrivate && !formData.password) {
      setError('Password is required for private rooms');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${config.getApiUrl()}/api/room/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomId: formData.roomId,
          creatorName: formData.playerName,
          maxPlayers: parseInt(formData.maxPlayers),
          isPrivate: formData.isPrivate,
          password: formData.password
        }),
      });

      const result = await response.json();

      if (result.success) {
        // Navigate to game with room data
        onNavigate('game', {
          roomId: formData.roomId,
          playerName: formData.playerName,
          password: formData.password
        });
      } else {
        setError(result.error || 'Failed to create room');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <button className="back-button" onClick={() => onNavigate('home')}>
          ← Back to Home
        </button>
        
        <h2>Create Game Room</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="form-container">
          <div className="form-group">
            <label htmlFor="roomId">Room ID:</label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input
                type="text"
                id="roomId"
                name="roomId"
                value={formData.roomId}
                onChange={handleInputChange}
                placeholder="Enter room ID"
                maxLength="10"
                required
              />
              <button type="button" onClick={generateRoomId} className="secondary-button">
                Generate
              </button>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="playerName">Your Name:</label>
            <input
              type="text"
              id="playerName"
              name="playerName"
              value={formData.playerName}
              onChange={handleInputChange}
              placeholder="Enter your name"
              maxLength="20"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="maxPlayers">Max Players:</label>
            <select
              id="maxPlayers"
              name="maxPlayers"
              value={formData.maxPlayers}
              onChange={handleInputChange}
            >
              <option value="2">2 Players</option>
              <option value="3">3 Players</option>
              <option value="4">4 Players</option>
            </select>
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              id="isPrivate"
              name="isPrivate"
              checked={formData.isPrivate}
              onChange={handleInputChange}
            />
            <label htmlFor="isPrivate">Private Room (requires password)</label>
          </div>

          {formData.isPrivate && (
            <div className="form-group">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="Enter room password"
                maxLength="20"
                required
              />
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="primary-button"
            style={{ width: '100%', marginTop: '20px' }}
          >
            {loading ? 'Creating Room...' : 'Create Room'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateRoom;
